import { compose } from 'recompose'
import ShopBySize from './ShopBySize'

export default compose()(ShopBySize)
